import { render, staticRenderFns } from "./blueBackground.vue?vue&type=template&id=2466ca3e"
import script from "./blueBackground.vue?vue&type=script&lang=js"
export * from "./blueBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports